import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MonoLabel({ children, className = "" }) {
  return (
    <p
      className={`font-mono text-[11px] uppercase tracking-[0.28em] text-gold ${className}`}
    >
      {children}
    </p>
  );
}

export function scrollToSection(e, hash) {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -64, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
}

export const HOURS = [
  { day: "Monday", time: "Closed", open: null },
  { day: "Tuesday", time: "11:00 AM – 8:00 PM", open: [11, 20] },
  { day: "Wednesday", time: "11:00 AM – 8:00 PM", open: [11, 20] },
  { day: "Thursday", time: "11:00 AM – 8:00 PM", open: [11, 20] },
  { day: "Friday", time: "11:00 AM – 8:00 PM", open: [11, 20] },
  { day: "Saturday", time: "11:00 AM – 8:00 PM", open: [11, 20] },
  { day: "Sunday", time: "Closed", open: null },
];

export function hoursInfo(now = new Date()) {
  const idx = (now.getDay() + 6) % 7;
  const row = HOURS[idx];
  let isOpen = false;
  if (row.open) {
    const h = now.getHours() + now.getMinutes() / 60;
    isOpen = h >= row.open[0] && h < row.open[1];
  }
  return { idx, row, isOpen };
}
